var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoUpcomingAppointment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.6465 11.5V19.75H5.89648V11.5C5.89648 9.9875 7.13398 8.75 8.64648 8.75H71.8965C73.409 8.75 74.6465 9.9875 74.6465 11.5Z",
    fill: "url(#paint0_linear_17899_612)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6465 19.75V74.75C74.6465 76.2625 73.409 77.5 71.8965 77.5H8.64648C7.13398 77.5 5.89648 76.2625 5.89648 74.75V19.75H74.6465Z",
    fill: "url(#paint1_linear_17899_612)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2715 12.875C39.5152 12.875 38.8965 12.2562 38.8965 11.5V6C38.8965 5.24375 39.5152 4.625 40.2715 4.625C41.0277 4.625 41.6465 5.24375 41.6465 6V11.5C41.6465 12.2562 41.0277 12.875 40.2715 12.875Z",
    fill: "#347BFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8965 12.875C27.1402 12.875 26.5215 12.2562 26.5215 11.5V6C26.5215 5.24375 27.1402 4.625 27.8965 4.625C28.6527 4.625 29.2715 5.24375 29.2715 6V11.5C29.2715 12.2562 28.6527 12.875 27.8965 12.875Z",
    fill: "#347BFA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5215 12.875C14.7652 12.875 14.1465 12.2562 14.1465 11.5V6C14.1465 5.24375 14.7652 4.625 15.5215 4.625C16.2777 4.625 16.8965 5.24375 16.8965 6V11.5C16.8965 12.2562 16.2777 12.875 15.5215 12.875Z",
    fill: "#347BFA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6465 12.875C51.8902 12.875 51.2715 12.2562 51.2715 11.5V6C51.2715 5.24375 51.8902 4.625 52.6465 4.625C53.4027 4.625 54.0215 5.24375 54.0215 6V11.5C54.0215 12.2562 53.4027 12.875 52.6465 12.875Z",
    fill: "#347BFA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0215 12.875C64.2652 12.875 63.6465 12.2562 63.6465 11.5V6C63.6465 5.24375 64.2652 4.625 65.0215 4.625C65.7777 4.625 66.3965 5.24375 66.3965 6V11.5C66.3965 12.2562 65.7777 12.875 65.0215 12.875Z",
    fill: "#347BFA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2715 28H12.7715C12.0121 28 11.3965 28.6156 11.3965 29.375V34.875C11.3965 35.6344 12.0121 36.25 12.7715 36.25H18.2715C19.0309 36.25 19.6465 35.6344 19.6465 34.875V29.375C19.6465 28.6156 19.0309 28 18.2715 28Z",
    fill: "url(#paint2_linear_17899_612)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7715 28H29.2715C28.5121 28 27.8965 28.6156 27.8965 29.375V34.875C27.8965 35.6344 28.5121 36.25 29.2715 36.25H34.7715C35.5309 36.25 36.1465 35.6344 36.1465 34.875V29.375C36.1465 28.6156 35.5309 28 34.7715 28Z",
    fill: "url(#paint3_linear_17899_612)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2715 28H45.7715C45.0121 28 44.3965 28.6156 44.3965 29.375V34.875C44.3965 35.6344 45.0121 36.25 45.7715 36.25H51.2715C52.0309 36.25 52.6465 35.6344 52.6465 34.875V29.375C52.6465 28.6156 52.0309 28 51.2715 28Z",
    fill: "url(#paint4_linear_17899_612)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7715 28H62.2715C61.5121 28 60.8965 28.6156 60.8965 29.375V34.875C60.8965 35.6344 61.5121 36.25 62.2715 36.25H67.7715C68.5309 36.25 69.1465 35.6344 69.1465 34.875V29.375C69.1465 28.6156 68.5309 28 67.7715 28Z",
    fill: "url(#paint5_linear_17899_612)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2715 44.5H12.7715C12.0121 44.5 11.3965 45.1156 11.3965 45.875V51.375C11.3965 52.1344 12.0121 52.75 12.7715 52.75H18.2715C19.0309 52.75 19.6465 52.1344 19.6465 51.375V45.875C19.6465 45.1156 19.0309 44.5 18.2715 44.5Z",
    fill: "url(#paint6_linear_17899_612)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7715 44.5H29.2715C28.5121 44.5 27.8965 45.1156 27.8965 45.875V51.375C27.8965 52.1344 28.5121 52.75 29.2715 52.75H34.7715C35.5309 52.75 36.1465 52.1344 36.1465 51.375V45.875C36.1465 45.1156 35.5309 44.5 34.7715 44.5Z",
    fill: "url(#paint7_linear_17899_612)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2715 44.5H45.7715C45.0121 44.5 44.3965 45.1156 44.3965 45.875V51.375C44.3965 52.1344 45.0121 52.75 45.7715 52.75H51.2715C52.0309 52.75 52.6465 52.1344 52.6465 51.375V45.875C52.6465 45.1156 52.0309 44.5 51.2715 44.5Z",
    fill: "url(#paint8_linear_17899_612)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7715 44.5H62.2715C61.5121 44.5 60.8965 45.1156 60.8965 45.875V51.375C60.8965 52.1344 61.5121 52.75 62.2715 52.75H67.7715C68.5309 52.75 69.1465 52.1344 69.1465 51.375V45.875C69.1465 45.1156 68.5309 44.5 67.7715 44.5Z",
    fill: "url(#paint9_linear_17899_612)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2715 61H12.7715C12.0121 61 11.3965 61.6156 11.3965 62.375V67.875C11.3965 68.6344 12.0121 69.25 12.7715 69.25H18.2715C19.0309 69.25 19.6465 68.6344 19.6465 67.875V62.375C19.6465 61.6156 19.0309 61 18.2715 61Z",
    fill: "url(#paint10_linear_17899_612)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7715 61H29.2715C28.5121 61 27.8965 61.6156 27.8965 62.375V67.875C27.8965 68.6344 28.5121 69.25 29.2715 69.25H34.7715C35.5309 69.25 36.1465 68.6344 36.1465 67.875V62.375C36.1465 61.6156 35.5309 61 34.7715 61Z",
    fill: "url(#paint11_linear_17899_612)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2715 61H45.7715C45.0121 61 44.3965 61.6156 44.3965 62.375V67.875C44.3965 68.6344 45.0121 69.25 45.7715 69.25H51.2715C52.0309 69.25 52.6465 68.6344 52.6465 67.875V62.375C52.6465 61.6156 52.0309 61 51.2715 61Z",
    fill: "url(#paint12_linear_17899_612)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17899_612",
    x1: 19.8983,
    y1: 8.66609,
    x2: 20.0249,
    y2: 19.7102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17899_612",
    x1: 5.89765,
    y1: 48.625,
    x2: 74.6469,
    y2: 48.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17899_612",
    x1: 13.0767,
    y1: 27.9371,
    x2: 13.6672,
    y2: 36.1789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_17899_612",
    x1: 29.5767,
    y1: 27.9371,
    x2: 30.1672,
    y2: 36.1789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_17899_612",
    x1: 46.0767,
    y1: 27.9371,
    x2: 46.6672,
    y2: 36.1789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_17899_612",
    x1: 62.5767,
    y1: 27.9371,
    x2: 63.1672,
    y2: 36.1789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_17899_612",
    x1: 13.0767,
    y1: 44.4371,
    x2: 13.6672,
    y2: 52.6789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_17899_612",
    x1: 29.5767,
    y1: 44.4371,
    x2: 30.1672,
    y2: 52.6789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_17899_612",
    x1: 46.0767,
    y1: 44.4371,
    x2: 46.6672,
    y2: 52.6789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_17899_612",
    x1: 62.5767,
    y1: 44.4371,
    x2: 63.1672,
    y2: 52.6789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_17899_612",
    x1: 13.0767,
    y1: 60.9371,
    x2: 13.6672,
    y2: 69.1789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_17899_612",
    x1: 29.5767,
    y1: 60.9371,
    x2: 30.1672,
    y2: 69.1789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_17899_612",
    x1: 46.0767,
    y1: 60.9371,
    x2: 46.6672,
    y2: 69.1789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUpcomingAppointment);
export default __webpack_public_path__ + "static/media/noUpcomingAppointment.3854f0af4a198247506fc333a9321beb.svg";
export { ForwardRef as ReactComponent };